import React from "react";

import "./assets/css/style.css";

function Loading() {
  return <div className="loading-container"></div>;
}

export default Loading;
